import * as tslib_1 from "tslib";
import { OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { CapacitacionService } from '../../../services/capacitacion.service';
import { NavigationService } from '../../../services/navigation.service';
import { MONTHS, MONTHS_BD } from '../../../utils/constants';
import { ZoneService } from 'src/app/services/zone.service';
import { EventEmitterService } from 'src/app/services/event-emitter.service';
import { EventYearService } from 'src/app/services/event-year.service';
import { EventMonthService } from 'src/app/services/event-month.service';
import { ExcelService } from 'src/app/services/excel.service';
import { ToastrService } from 'ngx-toastr';
import { EvidenciaService } from 'src/app/services/evidencia.service';
import { CategoryService } from '../../../services/category.service';
import { EnfoqueService } from '../../../services/enfoque.service';
import { EjecutorService } from '../../../services/ejecutor.service';
import { ValidationService } from '../../../services/validation.service';
import { LoginService } from 'src/app/services/login.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
export class TableViewComponent {
    constructor(capacitacionService, navigationService, excelService, eventMonthService, eventYearService, categoryService, enfoqueService, ejecutorService, validationService, zoneService, evidenciaService, toastr, eventEmitterService, loginService, modalService) {
        this.capacitacionService = capacitacionService;
        this.navigationService = navigationService;
        this.excelService = excelService;
        this.eventMonthService = eventMonthService;
        this.eventYearService = eventYearService;
        this.categoryService = categoryService;
        this.enfoqueService = enfoqueService;
        this.ejecutorService = ejecutorService;
        this.validationService = validationService;
        this.zoneService = zoneService;
        this.evidenciaService = evidenciaService;
        this.toastr = toastr;
        this.eventEmitterService = eventEmitterService;
        this.loginService = loginService;
        this.modalService = modalService;
        this.loading = false;
        this.year = new Date().getFullYear();
        this.month = null;
        this.contratista = "";
        this.empresa = "";
        this.zona = "";
        this.monthDB = [];
        this.yearsDB = [];
        this.rows = [];
        this.rowsOriginal = [];
        this.rowsAssitance = [];
        this.zonas = [];
        this.page = 1;
        this.pageSize = 10;
        this.totalAmmount = 0;
        this.sizeOptions = [
            { value: 10, label: "10 por página" },
            { value: 20, label: "20 por página" },
            { value: 50, label: "50 por página" },
        ];
        this.filtrando = false;
        this.searchT = "";
        this.confirmationModalHasComment = false;
        this.confirmationModalHasOptions = false;
        this.confirmationModalisCommentObligatory = false;
        this.confirmationModalOptionLabel = "Motivo";
        this.confirmationModalOptions = [
            { label: "No corresponde a actividad de capacitación", value: 1 },
            { label: "Actividad fuera del foco", value: 2 },
            { label: "Actividad no cumple los requerimientos en la forma", value: 3 },
            { label: "Cancelado", value: 4 },
            { label: "Actividad fuera del foco", value: 5 },
        ];
    }
    ngOnInit() {
        this.loadYear();
        if (this.eventEmitterService.subsFirst == undefined) {
            this.eventEmitterService.subsFirst =
                this.eventEmitterService.invokeFirstComponentFunction.subscribe((_name) => {
                    this.resetToFirstPageAndRefetch();
                });
        }
        if (this.eventYearService.subsVar == undefined) {
            this.eventYearService.subsVar =
                this.eventYearService.invokeFirstComponentFunction.subscribe((year) => {
                    const y = Number(year);
                    this.year = isNaN(y) ? this.year : y;
                    this.resetToFirstPageAndRefetch();
                });
        }
        if (this.eventMonthService.subsVar == undefined) {
            this.eventMonthService.subsVar =
                this.eventMonthService.invokeFirstComponentFunction.subscribe((month) => {
                    const m = month === "" ? null : Number(month);
                    this.month = m === null || isNaN(m) ? null : m;
                    this.resetToFirstPageAndRefetch();
                });
        }
        this.getZonas();
        if (!this.navigationService.getValidLogin())
            this.navigationService.goTo("/login");
        this.fetchCapacitaciones(this.year, this.toStrMonth(this.month), this.contratista, this.empresa, this.zona);
        this.categoryService
            .listWithFocos()
            .then((r) => (this.categoriesWithFocos = r))
            .catch(console.error);
        this.enfoqueService
            .list()
            .then((r) => (this.enfoques = r))
            .catch(console.error);
        this.ejecutorService
            .listWithRelatores()
            .then((r) => (this.ejecutoresWithRelatores = r))
            .catch(console.error);
    }
    ngAfterViewInit() { }
    ngOnDestroy() { }
    loadYear() {
        const current = new Date().getFullYear();
        this.yearsDB = [];
        for (let y = 2019; y <= current; y++)
            this.yearsDB.push(y);
        this.monthDB = [...MONTHS_BD];
    }
    toStrMonth(m) {
        return m == null ? "" : String(m);
    }
    getZonas() {
        return new Promise((resolve, reject) => {
            this.zoneService
                .getZonas()
                .then((response) => {
                this.zonas = response;
                resolve(response);
            })
                .catch((error) => reject(error));
        });
    }
    getMonthLabel(id) {
        console.log(id);
        const idx = id - 1;
        return MONTHS[idx].label;
    }
    onPageChange(newPage) {
        this.page = newPage;
        this.fetchCapacitaciones(this.year, this.toStrMonth(this.month), this.contratista, this.empresa, this.zona);
    }
    onPageSizeChange() {
        this.page = 1;
        this.fetchCapacitaciones(this.year, this.toStrMonth(this.month), this.contratista, this.empresa, this.zona);
    }
    resetToFirstPageAndRefetch() {
        this.page = 1;
        this.fetchCapacitaciones(this.year, this.toStrMonth(this.month), this.contratista, this.empresa, this.zona);
    }
    fetchCapacitaciones(year, month, contratista, empresa, zona) {
        this.loading = true;
        this.loginService.obtenerPermisosMenu("planificacion").then((response) => {
            this.rolid = response.data.rolId;
        });
        this.capacitacionService
            .getTotalAmmout(String(year), month, contratista, empresa, zona)
            .then((total) => (this.totalAmmount = total))
            .catch(console.error);
        this.capacitacionService
            .listPagination(this.page, this.pageSize, String(year), month, contratista, empresa, zona)
            .then((resp) => {
            const content = resp.content || resp.items || resp.data || [];
            this.rowsOriginal = content;
            this.rows = content.map((c) => this.buildRow(c));
            this.rowsAssitance = content.map((c) => c.assistanceRegistries);
            if (resp.totalElements != null)
                this.totalAmmount = resp.totalElements;
            if (resp.total != null)
                this.totalAmmount = resp.total;
            this.loading = false;
        })
            .catch((error) => {
            console.error(error);
            this.loading = false;
        });
    }
    getCapacitaciones() {
        // al cambiar filtros desde los selects, resetea a página 1
        this.resetToFirstPageAndRefetch();
    }
    //   export(): void {
    //     this.excelService.downloadCapacitaciones({
    //       String(year),
    // month, roleId, userId, empresaId, this.page, this.pageSize
    //     });
    //   }
    changeSearch(e) {
        const valor = e.target.value;
        if (valor.trim().length === 0) {
            this.filtrando = false;
            return;
        }
        this.filtrando = true;
        const word = valor.toLowerCase();
        this.rows = this.rowsOriginal
            .map((c) => this.buildRow(c))
            .filter((item) => {
            const str = (item.capacitacion.zoneDescription || "") +
                (item.capacitacion.nombreContratista || "") +
                (item.capacitacion.nombreTrabajador || "") +
                (item.capacitacion.name || "");
            return str.toLowerCase().includes(word);
        });
    }
    openInformationModal(modal, capacitacion, workers) {
        this.capacitacionModalMode = "read";
        this.capacitacionSelected = JSON.parse(JSON.stringify(capacitacion));
        this.capacitacionSelectedWorkers = JSON.parse(JSON.stringify(workers));
        this.capacitacionSelectedWorkersIds = (workers || []).map((w) => w.rutTrabajador);
        this.openModal(modal, { size: "lg" });
    }
    openEditionModal(modal, capacitacion, workers) {
        console.log(workers);
        this.capacitacionModalMode = "edit";
        capacitacion.statusCapacitacionLabel = capacitacion.stateShortDescription;
        this.capacitacionSelected = JSON.parse(JSON.stringify(capacitacion));
        this.capacitacionSelectedWorkers = JSON.parse(JSON.stringify(workers));
        this.capacitacionSelectedWorkersIds = (workers || []).map((w) => w.rutTrabajador);
        this.openModal(modal, { size: "lg" });
    }
    openDeleteModal(modal, capacitacion) {
        if (this.validationService.canDelete(capacitacion, String(this.rolid))) {
            this.confirmationModalHasComment = false;
            this.confirmationModalHasOptions = false;
            this.confirmationModalisCommentObligatory = false;
            this.capacitacionIdSelected = capacitacion.capacitacionId;
            this.confirmationModalTittle = "Eliminar capacitación";
            this.confirmationModalMessage = `¿Seguro que desea eliminar la capacitación "${capacitacion.name}"?`;
            this.confirmationModalAccept = this.onDeleteCapacitacion.bind(this);
            this.openModal(modal);
        }
    }
    openAcceptModal(modal, capacitacion, workers, editionModal) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.validationService.canAcceptOrReject(capacitacion, String(this.rolid)) ||
                this.validationService.canClose(capacitacion, String(this.rolid))) {
                this.confirmationModalHasOptions = false;
                this.confirmationModalisCommentObligatory = false;
                this.capacitacionIdSelected = capacitacion.capacitacionId;
                if (this.validationService.canAcceptOrReject(capacitacion, String(this.rolid))) {
                    this.confirmationModalTittle = "Aprobar capacitación";
                    this.confirmationModalMessage = `¿Seguro que desea aprobar la capacitación "${capacitacion.name}"?`;
                    this.confirmationModalHasComment = true;
                    this.confirmationModalAccept = this.onAcceptCapacitacion.bind(this);
                    this.openModal(modal);
                    return;
                }
                else {
                    this.evidencesCount = 0;
                    yield this.fetchEvidencia(capacitacion);
                    if (((Number.parseInt(capacitacion.realHours) || 0) > 0 &&
                        (Number.parseInt(capacitacion.realAssistants) || 0) > 0 &&
                        this.evidencesCount > 0 &&
                        capacitacion.realExecutionDate) ||
                        capacitacion.capacitacionTypeId == 2) {
                        this.confirmationModalTittle = "Cerrar capacitación";
                        this.confirmationModalMessage = `¿Seguro que desea cerrar la capacitación "${capacitacion.name}"?`;
                        this.confirmationModalHasComment = true;
                        this.confirmationModalAccept = this.onAcceptCapacitacion.bind(this);
                        this.openModal(modal);
                        return;
                    }
                    else {
                        if (this.validationService.canEdit(capacitacion)) {
                            this.capacitacionModalMode = "edit";
                            this.capacitacionSelected = JSON.parse(JSON.stringify(capacitacion));
                            this.capacitacionSelectedWorkers = JSON.parse(JSON.stringify(workers));
                            this.capacitacionSelectedWorkersIds = (workers || []).map((w) => w.rutTrabajador);
                            this.openModal(editionModal, { size: "lg" });
                            this.toastr.info("Actualiza: Duración Real, Asistentes Reales, Evidencia y Fecha Ejecución Real antes de cerrar", "Advertencia");
                            return;
                        }
                    }
                }
            }
        });
    }
    fetchEvidencia(capacitacion) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const evidencias = yield this.evidenciaService.list(capacitacion.capacitacionId);
                this.evidencesCount = evidencias.evidencias.length || 0;
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    openRejectModal(modal, capacitacion) {
        if (this.validationService.canAcceptOrReject(capacitacion, String(this.rolid))) {
            this.confirmationModalHasComment = true;
            this.confirmationModalHasOptions = true;
            this.confirmationModalisCommentObligatory = true;
            this.capacitacionIdSelected = capacitacion.capacitacionId;
            this.confirmationModalTittle = "Rechazar capacitación";
            this.confirmationModalMessage = `¿Seguro que desea rechazar la capacitación "${capacitacion.name}"?`;
            this.confirmationModalAccept = this.onRejectCapacitacion.bind(this);
            this.openModal(modal);
        }
    }
    openModal(modal, options = {}) {
        const modalOptions = Object.assign({ ariaLabelledBy: "modal-basic-title", centered: true }, options);
        this.modalService.open(modal, modalOptions);
    }
    onDeleteCapacitacion() {
        this.capacitacionService
            .delete(this.capacitacionIdSelected)
            .then(() => this.resetToFirstPageAndRefetch())
            .catch(console.error);
    }
    onAcceptCapacitacion(comment) {
        this.capacitacionService
            .accept(this.capacitacionIdSelected, sessionStorage.getItem("userid"), "0", comment)
            .then(() => { })
            .catch(console.error);
    }
    onRejectCapacitacion(comment, option) {
        this.capacitacionService
            .reject(this.capacitacionIdSelected, sessionStorage.getItem("userid"), option, comment)
            .then(() => { })
            .catch(console.error);
    }
    buildRow(c) {
        const cells = [
            { class: "td-centered", tooltip: false, content: c.capacitacion.capacitacionId },
            { class: "td-centered", tooltip: false, content: c.capacitacion.zoneDescription },
            {
                class: "td-centered",
                tooltip: false,
                content: c.capacitacion.capacitacionTypeDescription,
            },
            { class: "td-full", tooltip: true, content: c.capacitacion.name },
            { class: "td-truncated", tooltip: true, content: c.capacitacion.categoryDescription },
            { class: "td-truncated", tooltip: true, content: c.capacitacion.focoDescription },
            { class: "td-centered", tooltip: false, content: c.capacitacion.ejecutorDescription },
            {
                class: "td-centered",
                tooltip: false,
                content: this.getMonthLabel(c.capacitacion.month),
            },
            {
                class: "td-centered",
                tooltip: false,
                content: c.capacitacion.stateShortDescription,
            },
        ];
        console.log({
            capacitacion: c.capacitacion,
            workers: c.assistanceRegistries,
            id: c.capacitacion.capacitacionId,
            status: c.capacitacion.stateShortDescription,
            type: c.capacitacion.capacitacionTypeDescription,
            month: this.getMonthLabel(c.capacitacion.month),
            year: c.capacitacion.year,
            zone: c.capacitacion.zone,
            cells,
        });
        return {
            capacitacion: c.capacitacion,
            workers: c.assistanceRegistries,
            id: c.capacitacion.capacitacionId,
            status: c.capacitacion.stateShortDescription,
            type: c.capacitacion.capacitacionTypeDescription,
            month: this.getMonthLabel(c.capacitacion.month),
            year: c.capacitacion.year,
            zone: c.capacitacion.zone,
            cells
        };
    }
    exports(option) {
        if (typeof option === "number") {
            console.log(`Exportando página ${option}`);
            const obj = {
                year: String(this.year),
                month: this.month === null || this.month === 0 ? "all" : String(this.month),
                roleId: null,
                userId: null,
                empresaId: null,
                page: option,
                size: this.pageSize,
            };
            this.export(obj);
        }
        else if (option === "all") {
            console.log("Exportando todos los registros...");
            const obj = {
                year: String(this.year),
                month: this.month === null || this.month === 0 ? "all" : String(this.month),
                roleId: null,
                userId: null,
                empresaId: null,
                size: 0
            };
            this.export(obj);
        }
        else if (option === "current") {
            console.log("Exportando página actual...");
            const obj = {
                year: String(this.year),
                month: this.month === null || this.month === 0 ? "all" : String(this.month),
                roleId: null,
                userId: null,
                empresaId: null,
                page: this.page,
                size: this.pageSize,
            };
            this.export(obj);
        }
    }
    exportSpecificPage() {
        const input = prompt("Ingrese el número de página a exportar:");
        const page = Number(input);
        if (!isNaN(page) && page > 0) {
            const obj = {
                year: String(this.year),
                month: this.month === null || this.month === 0 ? "all" : String(this.month),
                roleId: null,
                userId: null,
                empresaId: null,
                page: page,
                size: this.pageSize,
            };
            this.export(obj);
        }
    }
    export(obj) {
        console.log(obj);
        console.log(JSON.stringify(obj));
        this.excelService.downloadCapacitaciones(obj).subscribe({
            next: () => console.log("Descarga iniciada correctamente"),
            error: (err) => {
                console.error("Error al descargar el Excel:", err);
                alert(err.message || "Ocurrió un error al generar el reporte.");
            },
        });
    }
}
